<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="content-wrapper" v-if="!isConfirm">
      <div class="container">
        <article id="article">
          <div class="section1" id="top-img" style="padding-bottom: 80px;">
              <img src="/lib/images/maintenance_pack_500.jpg" width="100%" alt="">
              <div class="section" style="padding-top: 0px; padding-bottom: 0px;">
                  <button class="button fs16" v-on:click="specifiedCommercialTransactions()">特定商取引法の表記</button>
              </div>
          </div>
          <div class="section mp-fixed" v-if="subscriptionDisabled">
            <button class="button fs16" v-on:click="subscription()">この商品を申し込む</button>
          </div>
          <div class="section white-panel" v-if="!subscriptionDisabled">
            <p class="fs13 font-weight-bold text-center mb4">ご契約ID：{{ subscriptionId }}</p>
          </div>

          <div class="section3 pb40 mb4" v-if="editAreaDisabled">
            <div class="pt24 pr16 pb20 pl16 mb8 radius8">
              <p class="fs17 font-weight-bold color-red2 text-center mb4" v-if="paymentReminderDisabled">入会金のお支払いを店舗にて実施してください。</p>
            </div>
            <div class="content-box mt24 ml16 mr16 mb16" v-if="creditCardAreadDisabled.isShow">
              <div class="content-box__1 mr24 ml24">
                <h3 class="content-box__ttl mb16">{{ creditCard.Text }}</h3>
                <div class="content-box-btn">
                  <button class="button fs16 mt8 mb28 mr14 ml14 pd16 w90p" v-bind:disabled="this.creditCardAreadDisabled.isButton" v-on:click="gmoCardEntry()">{{ creditCard.ButtonText }}</button>
                </div>
              </div>
              <div class="content-box__1 mr16 ml16 mb16">
              </div>
            </div>
            <div class="content-box mt24 ml16 mr16 mb16" v-if="firstPaymentAreaDisabled.isShow">
              <div class="content-box__1 mr24 ml24">
                <h3 class="content-box__ttl mb16">下記のボタンより決済いただくとサービスが開始されます。</h3>
                <button class="button fs16 mt8 mb28 mr14 ml14 pd16" v-bind:disabled="this.firstPaymentAreaDisabled.isButton" v-on:click="firstPaymentFinalConfirmation()">注文内容の確認</button>
              </div>
              <div class="content-box__1 mr16 ml16 mb16">
              </div>
            </div>
            <div class="content-box mt24 ml16 mr16 mb16" v-if="carInfoAreaDisabled">
              <div class="content-box__1 mr24 ml24">
                <h3 class="content-box__ttl mb16">ご登録/申込いただく車検証を確認いただけます。</h3>
                <button class="button fs16 mt8 mb28 mr14 ml14 pd16" v-on:click="checkCarInfo()">車検証を確認する</button>
              </div>
              <div class="content-box__1 mr16 ml16 mb16">
              </div>
            </div>
            <div class="content-box mt24 ml16 mr16 mb16" v-if="lateFeesAreaDisabled.isShow">
              <div class="content-box__1 mr24 ml24">
                <h3 class="content-box__ttl mb16">
                  ご登録いただいたお支払情報(クレジットカード)にて、<br>
                  今月分の決済ができませんでした。<br>
                  お手数ですが、未納分のお支払手続きをお願い致します。
                </h3>
                <button class="button fs16 mt8 mb28 mr14 ml14 pd16" v-bind:disabled="this.lateFeesAreaDisabled.isButton" v-on:click="gmoLinkType()">未納分の料金を支払う</button>
              </div>
              <div class="content-box__1 mr16 ml16 mb16">
              </div>
            </div>
            <div class="content-box mt24 ml16 mr16 mb16" v-if="cancelAreaDisabled.isShow">
              <div class="content-box__1 mr24 ml24">
                <h3 class="content-box__ttl mb16">解約における注意事項</h3>
                <div class="bg-gray1 pt24 pr16 pb20 pl16 mb16 radius8 fs10 mp-cancel-content-box">
                  <ul>
                    <li class="title-li">＜洗車プリペイドについて＞</li>
                    <li>利用者が本サービスを中途解約した場合、翌月の洗車プリペイドのサービスを受けることが出来なくなります。当月に付与された洗車プリペイドは6か月間利用可能です。</li>
                    <li>例）中途解約を6月20日にした場合、</li>
                    <li>
                      <ul class="example-area">
                        <li>6月分として付与された洗車プリペイドは11月末まで利用することが出来ます。<br>洗車プリペイドは付与された月から6か月間有効となります。</li>
                        <li>7月分として付与される洗車プリペイドのサービスを受けることが出来なくなります。</li>
                      </ul>
                    </li>
                    <li class="title-li">＜燃料割引について＞</li>
                    <li>利用者が本サービスを中途解約した場合、翌々月の燃料割引のサービスを受けることが出来なくなります。</li>
                    <li>例）中途解約を6月20日にした場合、</li>
                    <li>
                      <ul class="example-area">
                        <li>7月末まで燃料割引のサービスを受けることができます。</li>
                        <li>8月分の燃料割引のサービスを受けることが出来なくなります。</li>
                      </ul>
                    </li>
                    <li class="title-li">＜6か月ごとの点検ならびにオイル交換について＞</li>
                    <li>利用者が本サービスを中途解約した場合、解約日以降に予定していた点検ならびにオイル交換のサービスを受けることが出来なくなります。</li>
                    <li>例）点検ならびにオイル交換を6月20日に実施予定の場合、</li>
                    <li>
                      <ul class="example-area">
                        <li>6月19日（点検ならびにオイル交換実施予定日前）に解約した場合、20日の点検ならびにオイル交換は受けられません。</li>
                        <li>6月21日（点検ならびにオイル交換実施後）に解約した場合、そのまま解約することが出来ます。</li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <button class="button fs16 mt8 mb28 mr14 ml14 pd16" v-bind:disabled="this.cancelAreaDisabled.isButton" v-on:click="cancel()">解約する</button>
                <div v-if="this.cancelAreaDisabled.isButton">
                  <p class="fs13 font-weight-bold color-red1 text-center mb4">本サービスは月末日の解約が出来ません。<br>お手数ですが、後日(月末日をさけて)改めてお試しください。</p>
                </div>
              </div>
              <div class="content-box__1 mr16 ml16 mb16">
              </div>
            </div>
          </div>
        </article>
        <!-- カーケアTOPに戻るボタン -->
        <form name="fm">
          <input id="tsid" type="hidden" name="tsid" v-bind:value="this.nativeData.tsid">
          <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="this.nativeData.popinfoid">
          <input id="otoken" type="hidden" name="otoken" v-bind:value="this.nativeData.otoken">
          <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.versionData.appVersion">
          <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.versionData.platform">
          <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.versionData.osVersion">
        </form>
        <!-- /.modal_body -->
      </div>
      <!-- /.modal_container -->
    </div>
    <FirstPaymentFinalConfirmation
      v-if="isConfirm"
      v-bind:linkTypeGetRequestBodyParam="linkTypeGetRequestBodyParam"
      @gmoLinkType="gmoLinkType"
      @backToTop="backToTop">
    </FirstPaymentFinalConfirmation>
  </div>
</template>

<script>
import modal from '@/assets/v3/modal'
import Loading from '@/views/v3/Loading.vue'
import config from '@/v3/config'
import subscription from '@/store/Api/MaintenancePack/subscription'
import car from '@/store/Api/car'
import userInfo from '@/store/Api/Common/userInfo'
import gmoCardEntry from '@/store/Api/MaintenancePack/GMO/cardEntryGet'
import gmoLinkType from '@/store/Api/MaintenancePack/GMO/linkTypeGet'
import FirstPaymentFinalConfirmation from '@/views/v3/MaintenancePack/FirstPaymentFinalConfirmation'
import { useGmoPageStore } from '@/store/gmoPage'

export default {
  data () {
    return {
      loading: true,
      isConfirm: false,
      creditCard: {
        Text: '毎月のお支払でご利用いただくクレジットカード情報を登録してください。',
        ButtonText: 'クレジットカードを登録/変更する'
      },
      paymentReminderDisabled: true,
      subscriptionDisabled: true,
      editAreaDisabled: false,
      creditCardAreadDisabled: {
        isShow: false,
        isButton: false
      },
      firstPaymentAreaDisabled: {
        isShow: false,
        isButton: true
      },
      carInfoAreaDisabled: false,
      lateFeesAreaDisabled: {
        isShow: false,
        isButton: false
      },
      cancelAreaDisabled: {
        isShow: false,
        isButton: false
      },
      cardEntryGetRequestBodyParam: {
        authid: '',
        tsid: '',
        popinfo_id: '',
        otoken: '',
        ss_code: ''
      },
      linkTypeGetRequestBodyParam: {
        authid: '',
        maintenance_pack_subscription_id: '',
        tsid: '',
        popinfo_id: '',
        otoken: '',
        ss_code: '',
        card_no: '',
        pin_cd: '',
        amount: '',
        category: ''
      },
      subscriptionId: null
    }
  },
  methods: {
    openErrorModal (message) {
      modal.alert(message)
    },
    openMpCancelModal (message, headersInfo) {
      modal.mpCancelAlert(message, headersInfo)
    },
    openAdmissionFeeReminder (message) {
      modal.admissionFeeReminderAlert(message)
    },
    openSpecifiedCommercialTransactionsModal () {
      modal.mpSpecifiedCommercialTransactionsAlert()
    },
    setCarInfo (carInfo) {
      this.carInfo = carInfo
    },
    setUserInfo (userInfo) {
      this.userInfo = userInfo
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    setSubscriptionInfo (subscriptionInfo) {
      this.subscriptionInfo = subscriptionInfo
    },
    setAppVersionHeader (appVersion, platform, osVersion) {
      this.appVersionHeader = `${appVersion}/${platform}/${osVersion}`
    },
    setFirstPaymentButtonDisabled (checkFirstPaymentButtonDisabled) {
      this.firstPaymentButtonDisabled = checkFirstPaymentButtonDisabled
    },
    setFirstPaymentButtonDisabledForPhase1 () {
      this.firstPaymentButtonDisabled = true
    },
    subscription () {
      this.nativeEVENTSet('MpTopButton', 'MOVED_MP_SUBSCRIPTION', 'TAP')
      this.$router.push({
        name: 'MaintenancePackApplyV3',
        query: {
          tsid: this.nativeData.tsid,
          popinfoid: this.nativeData.popinfoid,
          otoken: this.nativeData.otoken,
          ss_code: this.ssCode,
          appVersion: this.versionData.appVersion,
          platform: this.versionData.platform,
          osVersion: this.versionData.osVersion,
          cource_id: config.MAINTENANCE_PACK_COURCE.COURCE_A.ID,
          cource_name: config.MAINTENANCE_PACK_COURCE.COURCE_A.NAME
        }
      })
    },
    checkCarInfo () {
      this.nativeEVENTSet('MpTopButton', 'MOVED_SHAKEN_DATA', 'TAP')
      this.$router.push({
        name: 'CarInspectionConfirmV3',
        query: {
          tsid: this.nativeData.tsid,
          carid: this.carInfo.id,
          popinfoid: this.nativeData.popinfoid,
          otoken: this.nativeData.otoken,
          ssCode: this.ssCode,
          appVersion: this.versionData.appVersion,
          platform: this.versionData.platform,
          osVersion: this.versionData.osVersion
        }
      })
    },
    async gmoCardEntry () {
    // 戻るボタンの出し分け
      this.appDisplayBack(false)
      this.nativeEVENTSet('MpTopButton', 'MOVED_GMO_EDIT_CREDIT', 'TAP')
      this.creditCardAreadDisabled.isButton = true
      // authid 以外のパラメータをセット
      this.cardEntryGetRequestBodyParam.tsid = this.nativeData.tsid
      this.cardEntryGetRequestBodyParam.popinfo_id = this.nativeData.popinfoid
      this.cardEntryGetRequestBodyParam.otoken = this.nativeData.otoken
      this.cardEntryGetRequestBodyParam.ss_code = this.ssCode
      await gmoCardEntry.post(this.cardEntryGetRequestBodyParam, this.appVersionHeader).then(res => {
        const gmoPage = res.data
        const gmoPageStore = useGmoPageStore()
        gmoPageStore.gmoPage = gmoPage
        this.$router.push({
          name: 'PaymentV3'
        })
      }).catch(e => {
        console.log('gmoCardEntry-error')
        console.log(e.message)
        this.openErrorModal('ただいまアクセスが集中している可能性がございます。恐れ入りますが、時間をおいて再度お試しください。')
      })
      this.creditCardAreadDisabled.isButton = false
    },
    async gmoLinkType () {
    // 戻るボタンの出し分け
      this.appDisplayBack(false)
      if (this.linkTypeGetRequestBodyParam.category === config.GMO_PAYMENT_CLASSIFICATION.FIRST_PAYMENT) {
        this.nativeEVENTSet('MpTopButton', 'MOVED_GMO_SETTLEMENT_FOR_FIRST_PAYMENT', 'TAP')
      } else {
        this.nativeEVENTSet('MpTopButton', 'MOVED_GMO_SETTLEMENT_FOR_LATE_FEES', 'TAP')
      }
      this.firstPaymentAreaDisabled.isButton = true
      this.lateFeesAreaDisabled.isButton = true
      await gmoLinkType.post(this.linkTypeGetRequestBodyParam, this.appVersionHeader).then(res => {
        const gmoPage = res.data
        const gmoPageStore = useGmoPageStore()
        gmoPageStore.gmoPage = gmoPage
        this.$router.push({
          name: 'PaymentV3'
        })
      }).catch(e => {
        console.log('gmoLinkType-error')
        console.log(e.message)
        this.openErrorModal('ただいまアクセスが集中している可能性がございます。恐れ入りますが、時間をおいて再度お試しください。')
      })
      this.firstPaymentAreaDisabled.isButton = false
      this.lateFeesAreaDisabled.isButton = false
    },
    cancel () {
      this.nativeEVENTSet('MpTopButton', 'OPNE_CANCEL_MODAL', 'TAP')
      const cancelApiHeader = []
      const body = []
      body.authid = this.userInfo.authid
      body.ss_code = this.ssCode
      body.tsid = this.nativeData.tsid
      body.otoken = this.nativeData.otoken
      cancelApiHeader.appVersion = this.appVersionHeader
      cancelApiHeader.body = body

      this.openMpCancelModal('本当に解約してよろしいですか？「解約する」ボタンを押下すると解約されます。', cancelApiHeader)
    },
    /**
     * 初回決済ボタンの活性・非活性の判定を行う
     *  活性条件：現在日が、満了日の1か月前 ～ 満了日の翌月末以内 または、
     *           現在日が、満了日の25か月前 ～ 満了日の23カ月前の月末 以内
     * @param {string} expiryOn - 車検満了日
     * @return {boolean} - 初回決済ボタンの活性・非活性の判定結果
     */
    checkFirstPaymentButtonDisabled (expiryOn) {
      let result = false
      let expiryOnDate = new Date(expiryOn)
      expiryOnDate.setHours(0, 0, 0, 0)
      let nowDate = new Date()
      nowDate.setHours(0, 0, 0, 0)
      // 満了日から1か月前
      const mounth1 = -1
      const targetMonth1 = this.getTargetDate(expiryOnDate, mounth1)
      // 満了日の翌月末
      const experyOnMounth1after = 1
      const experyOnTargetMonth1after = this.getTargetDate(expiryOnDate, experyOnMounth1after, true)
      // 満了日から23か月前の月末
      const experyOnMounth23 = -23
      const experyOnTargetMonth23 = this.getTargetDate(expiryOnDate, experyOnMounth23, true)
      // 満了日から25か月前
      const experyOnMounth25 = -25
      const experyOnTargetMonth25 = this.getTargetDate(expiryOnDate, experyOnMounth25)

      nowDate = nowDate.getTime()
      expiryOnDate = expiryOnDate.getTime()

      // 現在日が、満了日の1か月前 ～ 満了日の翌月末 以内である
      if (targetMonth1 <= nowDate && nowDate <= experyOnTargetMonth1after) {
        result = true
      }
      // 現在日が、満了日の25か月前 ～ 満了日の23カ月前の月末 以内である
      if (experyOnTargetMonth25 <= nowDate && nowDate <= experyOnTargetMonth23) {
        result = true
      }

      return result
    },
    /**
     * 任意の日付（月単位）をミリ秒数で返す関数
     * @param {string} date - 現在の年月日
     * @param {number} targetMonth - 任意の月[満了日から](1か月前[-1], 翌月末[1], 23か月前の月末[-23], 25か月前[-25])
     * @return {number} - 該当する日付のミリ秒
     */
    getTargetDate (date, targetMonth, checkPaymentButton) {
      // 基準の年月日を取得
      const year = date.getFullYear()
      const month = date.getMonth()
      const day = date.getDate()

      // 基準の年月からDateオブジェクトを生成
      const nextDate = new Date(year, month)
      // 月の設定を変更
      nextDate.setMonth(nextDate.getMonth() + targetMonth)
      // 末日を取得
      const lastDay = new Date(nextDate.getFullYear(), nextDate.getMonth() + 1, 0).getDate()

      if (!checkPaymentButton) {
        // 元の日にちが該当月に無い場合はその月の末日を設定する
        if (lastDay < day) {
          nextDate.setDate(lastDay)
        } else {
          nextDate.setDate(day)
        }
      } else {
        nextDate.setDate(lastDay)
      }

      return nextDate.getTime()
    },
    /**
     * 解約ボタン活性・非活性の判定を行う
     *  活性条件：月末日でないこと
     * @return {boolean} - 解約ボタンの活性・非活性の判定結果
     */
    checkCancelButtonDisabled () {
      let result = true
      let nowDate = new Date()
      nowDate.setHours(0, 0, 0, 0)

      // 現在日の月末日
      let lastDayOfTheMonth = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0)

      nowDate = nowDate.getTime()
      lastDayOfTheMonth = lastDayOfTheMonth.getTime()

      // 現在日が、月末日である
      if (nowDate === lastDayOfTheMonth) {
        result = false
      }
      return result
    },
    // 特定商取引法の表記ボタン
    specifiedCommercialTransactions () {
      this.openSpecifiedCommercialTransactionsModal()
    },
    // 注文内容の確認ボタン
    firstPaymentFinalConfirmation () {
      this.isConfirm = true
    },
    // 戻るボタン（最終確認）
    backToTop () {
      this.isConfirm = false
      // イメージ画像を各種ボタン要素の下に配置する
      setTimeout(() => {
        const list = document.getElementById('article')
        const img = document.getElementById('top-img')
        list.appendChild(img)
      })
    }
  },
  computed: {
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      return getData
    },
    ssCode: function () {
      // ネイティブから取得したデータを格納する。
      const getData = this.$route.query.ss_code
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.appVersion
      getData.platform = this.$route.query.platform
      getData.osVersion = this.$route.query.osVersion
      return getData
    }
  },
  async mounted () {
    this.$loadScript('https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js')
    this.$loadScript('/lib/js/main.js')

    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    let isApiError = false

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.appVersion, this.$route.query.platform, this.$route.query.osVersion)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    this.setAppVersionHeader(this.$route.query.appVersion, this.$route.query.platform, this.$route.query.osVersion)

    this.linkTypeGetRequestBodyParam.tsid = this.nativeData.tsid
    this.linkTypeGetRequestBodyParam.popinfo_id = this.nativeData.popinfoid
    this.linkTypeGetRequestBodyParam.otoken = this.nativeData.otoken
    this.linkTypeGetRequestBodyParam.ss_code = this.ssCode

    // TODO::決済金額(amount)は商品一覧取得APIが実装されるまではハードコードで対応
    this.linkTypeGetRequestBodyParam.amount = config.GMO_LINK_TYPE_API_AMOUNT

    // 車検証情報取得
    await car.get(this.nativeData.tsid).then(res => {
      this.setCarInfo(res.data.car[0])
    }).catch(e => {
      console.log('car-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // ユーザー情報取得
    await userInfo.get(this.nativeData, this.appVersionHeader).then(res => {
      this.setUserInfo(res.data.body.id)
      if (this.userInfo.authid) {
        this.cardEntryGetRequestBodyParam.authid = this.userInfo.authid
        this.linkTypeGetRequestBodyParam.authid = this.userInfo.authid
      }
    }).catch(e => {
      console.log('userInfo-error')
      console.log(e)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (this.userInfo.authid) {
      // メンテパック申込情報取得
      const queryParameter = `?authid=${this.userInfo.authid}&ss_code=${this.ssCode}`
      await subscription.get(queryParameter).then(res => {
        let record = null
        if (res.data[0]) {
          record = res.data[0].maintenance_pack_subscription
        }
        this.setSubscriptionInfo(record)
        if (this.subscriptionInfo) {
          this.linkTypeGetRequestBodyParam.maintenance_pack_subscription_id = this.subscriptionInfo.id
          this.linkTypeGetRequestBodyParam.card_no = this.subscriptionInfo.tmn_card_no
          this.linkTypeGetRequestBodyParam.pin_cd = this.subscriptionInfo.tmn_pin_cd
          this.subscriptionId = this.subscriptionInfo.id

          // メンテナンスパックリリース時（2022/11/1）にデータ移行にて登録された「メンテナンスパック申込情報テーブル」の該当 ID は、車検満了日に関わらず活性と判定する
          const phase1IdsStart = process.env.VUE_APP_MP_SUBSCRIPTION_PHASE_1_IDS_START
          const phase1IdsEnd = process.env.VUE_APP_MP_SUBSCRIPTION_PHASE_1_IDS_END
          if (phase1IdsStart && phase1IdsEnd && phase1IdsStart <= this.subscriptionInfo.id && this.subscriptionInfo.id <= phase1IdsEnd) {
            // フェーズ1の移行データ（メンテナンスパック申込情報テーブル）の ID 範囲に含まれる ID の場合は、初回決済を可能にする
            this.setFirstPaymentButtonDisabledForPhase1()
            console.log('set-first-payment-button-for-mp-subscription-phase1-id')
            console.log(phase1IdsStart, phase1IdsEnd, this.subscriptionInfo.id)
          } else {
            console.log('not-mp-subscription-phase1-id')
            // 初回決済ボタン活性・非活性チェック
            this.setFirstPaymentButtonDisabled(this.checkFirstPaymentButtonDisabled(this.subscriptionInfo.register_expiry_on))
          }
        }
      }).catch(e => {
        console.log('subscription-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    }

    // メンテパック仮申し込み済み
    if (this.subscriptionInfo) {
      this.subscriptionDisabled = false
      this.editAreaDisabled = true

      // イメージ画像を各種ボタン要素の下に配置する
      const list = document.getElementById('article')
      const img = document.getElementById('top-img')
      list.appendChild(img)

      // 入会金支払い済み
      if (this.subscriptionInfo.admission_fee_payment_at !== null) {
        // [入会金払ってください] 文言非表示
        this.paymentReminderDisabled = false
        if (this.firstPaymentButtonDisabled) {
          // 初回決済ボタン活性
          this.firstPaymentAreaDisabled.isButton = false

          this.linkTypeGetRequestBodyParam.category = config.GMO_PAYMENT_CLASSIFICATION.FIRST_PAYMENT
        }
        // [メンテパック用車検証確認] 部分表示
        this.carInfoAreaDisabled = true
      } else {
        this.openAdmissionFeeReminder('お申込いただいた店舗にて入会金のお支払をお願い致します。')
      }

      // 初回未決済
      if (this.subscriptionInfo.first_payment_at === null) {
        // [初回決済]部分表示
        this.firstPaymentAreaDisabled.isShow = true
      } else {
        // [入会金払ってください] 文言非表示
        this.paymentReminderDisabled = false
        // クレジットカード部分の文言を切り替え
        this.creditCard.Text = '毎月のお支払でご利用いただくクレジットカード情報を変更できます。'
        this.creditCard.ButtonText = 'クレジットカードを変更する'
      }

      // 滞納金未払い
      if (this.subscriptionInfo.payment_failure_at === null) {
        // [クレジットカード登録・変更] 部分表示
        this.creditCardAreadDisabled.isShow = true

        // [解約] 部分表示
        this.cancelAreaDisabled.isShow = true
        if (!this.checkCancelButtonDisabled()) {
          this.cancelAreaDisabled.isButton = true
        }
      } else {
        this.linkTypeGetRequestBodyParam.category = config.GMO_PAYMENT_CLASSIFICATION.LATE_FEES_SETTLEMENT
        // [滞納金支払い] 部分表示
        this.lateFeesAreaDisabled.isShow = true
      }
    }

    if (!isApiError) {
      this.loading = false
    }
    this.nativePVset('MpTop')
  },
  components: {
    Loading,
    FirstPaymentFinalConfirmation
  }
}

</script>
